import { Image, Box } from "@chakra-ui/react";
import { ReviewCard } from "modules/common/components";
import { boxStyles, imageStyles } from "./TrustpilotTestimonialDesktop.styles";
import type { TrustpilotTestimonialDesktopProps } from "./TrustpilotTestimonialDesktop.d";

export const TrustpilotTestimonialDesktop = ({
  cardPosition,
  imageProps,
  review,
  sbEditable,
}: TrustpilotTestimonialDesktopProps) => {
  const positionStyles = { transform: `translate(${cardPosition === "left" ? "-10%" : "50%"}, 20%)` };
  return (
    <Box pos="relative" {...sbEditable}>
      <Image {...imageProps} {...imageStyles} />
      <Box {...boxStyles} {...positionStyles}>
        <ReviewCard review={review} />
      </Box>
    </Box>
  );
};
